import { render, staticRenderFns } from "./dialog-edit-number.vue?vue&type=template&id=dd6b44dc&scoped=true&"
import script from "./dialog-edit-number.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-number.vue?vue&type=script&lang=js&"
import style0 from "./dialog-edit-number.vue?vue&type=style&index=0&id=dd6b44dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6b44dc",
  null
  
)

export default component.exports